import { generateQueryParams2 } from 'utils'
import CommonService from './common.service'
import { _object } from 'utils/interfaces'

class CustomersService extends CommonService {
  async getCustomers(params: _object) {
    return await this.get(`/users?${generateQueryParams2(params)}`)
  }

  async AddCustomer(params: _object) {
    return await this.post('/users', params)
  }

  async getCustomerDetails(id: string | undefined) {
    return await this.get(`/users/${id}`)
  }

  async deleteCustomer(id: string | undefined) {
    return await this.delete(`/users/${id}`)
  }

  async UpdateCustomer(id: string | undefined, params: { [key: string]: string }) {
    return await this.put(`/users/${id}`, params)
  }
}

export const customersService = new CustomersService()
